export const chatContainerStyles =
  isLastMessageInParticipantBatch => theme => ({
    px: 5,
    width: '100%',
    mb: isLastMessageInParticipantBatch ? 6 : 1,

    [theme.breakpoints.down('sm')]: {
      px: 3
    }
  });

export const messageContainerStyles = isOutgoing => ({
  display: 'flex',
  flexDirection: isOutgoing ? 'row' : 'row-reverse',
  justifyContent: 'flex-start'
});

export const avatarContainerStyles = isOutgoing => ({
  [isOutgoing ? 'pr' : 'pl']: 1,
  pt: 0.5
});

export const avatarSpacerStyles = {
  height: 'auto',
  width: '48px',
  minWidth: '48px',
  px: 1
};
